<template>
  <div class="question-item bg-white box-border px-10 py-4" :data-id="question.q_id">
    <div class="relative">
      <div :class="{ 'unknown-wrap': question.issue.show_unknown }">
        <div ref="title" class="q-title leading-22 break-words" v-html="title"></div>
      </div>
      <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
        <div ref="note" class="q-desc break-words leading-22 pl-5" :class="getNoteClass" v-if="showNote">
          <div v-html="question.note"></div>
        </div>
        <div v-if="isOverFlowNote" class="operate-btn cursor-pointer" @click="isOpenNote = !isOpenNote">
          <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
          <span>
            <i :class="isOpenNote ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>
      </div>

      <div class="q-content pl-5 mt-3" ref="qContent">
        <component :is="componentName" :question="question"></component>
      </div>

      <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
        <div class="pl-5">
          <adapter-upload-files :content="content" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { componentMap, typeMapping } from 'dygc'
import { components } from '@/questions'
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'QuestionItem',
  components: { AdapterUploadFiles, ...components },
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    enableQuestionIndex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpenNote: false,
      isOverFlowNote: true
    }
  },
  computed: {
    title() {
      const content = this.question.content
      return content.richText || content.text
    },
    content() {
      return this.question.content
    },
    componentName() {
      if (this.question.issue.getComponentType) {
        return this.question.issue.getComponentType()
      } else {
        return componentMap.get(this.question.questionType)
      }
    },
    showNote() {
      if (!this.question.setting.enableNote) return false
      return !!this.question.note
    },
    getNoteClass() {
      if (!this.question.setting.enableFold) return ''
      if (!this.isOverFlowNote) return ''
      return this.isOpenNote ? '' : 'fixed-height-note'
    }
  },
  methods: {
    initTitle() {
      let child = this.$refs.title.childNodes[0]
      let el = child
      if (child.nodeType !== 1) {
        el = this.$refs.title
      }
      const nodes = []
      const enableQuestionIndex = this.enableQuestionIndex
      if (enableQuestionIndex && this.question.num) {
        let span = document.createElement('span')
        span.innerText = `${this.question.num}.`
        span.className = 'mr-1'
        nodes.push(span)
      }
      if (this.question.required) {
        let span = document.createElement('span')
        span.innerText = '*'
        span.className = 'text-red mr-1'
        nodes.push(span)
      }
      for (const node of nodes) {
        el.insertBefore(node, el.childNodes[0])
      }
      if (this.question.issue.defaultTip) {
        const span = document.createElement('span')
        span.innerText = `【${this.question.issue.defaultTip}】`
        el.appendChild(span)
      }

      if (this.hasAnswerScore) {
        const span = document.createElement('span')
        span.innerHTML = `<span>${this.totalScore} 分</span>`
        span.className = 'text-theme-black-450 px-2 leading-22 rounded-small ml-2'
        el.appendChild(span)
      }
      // const typeText = typeMapping.get(this.question.questionType)
      // if (this.$bus.enableQuestionType && typeText) {
      //   const span = document.createElement('span')
      //   span.innerHTML = `<span>【${typeText}】</span>`
      //   span.className = 'bg-theme-100 text-theme-700 leading-22 rounded-small ml-2'
      //   el.appendChild(span)
      // }
      previewImage(this.$refs.title)
      previewImage(this.$refs.qContent)
      let note = this.$refs.note
      if (note) {
        this.isOverFlowNote = note.clientHeight < note.scrollHeight
      } else {
        this.isOverFlowNote = false
      }
    }
  },
  mounted() {
    this.initTitle()
  }
}
</script>
